import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  HStack,
  Text,
  Icon,
  Button
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { FaGlobe, FaCheck } from 'react-icons/fa';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSelector = ({ variant = 'icon' }) => {
  const { language, changeLanguage } = useLanguage();
  const bgColor = 'white';
  const borderColor = 'gray.200';

  const languages = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  ];

  // Compact variant for top bar
  if (variant === 'compact') {
    return (
      <Menu>
        <MenuButton
          as={Button}
          size="xs"
          variant="solid"
          bg="white"
          color="black"
          _hover={{ bg: 'gray.100' }}
          rightIcon={<ChevronDownIcon />}
          fontFamily="Roboto, sans-serif"
        >
          {languages.find((l) => l.code === language)?.nativeName || 'English'}
        </MenuButton>
        <MenuList bg={bgColor} borderColor={borderColor}>
          {languages.map((lang) => (
            <MenuItem
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              bg="white"
              _hover={{ bg: 'gray.50' }}
              fontFamily="Roboto, sans-serif"
              color="black"
              fontWeight={language === lang.code ? '600' : '400'}
            >
              <HStack spacing={2} w="100%">
                <Text flex={1}>{lang.nativeName}</Text>
                {language === lang.code && (
                  <Icon as={FaCheck} color="black" />
                )}
              </HStack>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    );
  }

  if (variant === 'icon') {
    return (
      <Menu>
        <MenuButton
          as={IconButton}
          icon={<FaGlobe />}
          variant="ghost"
          aria-label="Select Language"
        />
        <MenuList bg={bgColor} borderColor={borderColor}>
          {languages.map((lang) => (
            <MenuItem
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              bg="white"
              _hover={{ bg: 'gray.50' }}
              fontFamily="Roboto, sans-serif"
              color="black"
              fontWeight={language === lang.code ? '600' : '400'}
            >
              <HStack spacing={2} w="100%">
                <Text flex={1}>{lang.nativeName}</Text>
                {language === lang.code && (
                  <Icon as={FaCheck} color="black" />
                )}
              </HStack>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    );
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="outline"
        leftIcon={<Icon as={FaGlobe} />}
        rightIcon={<ChevronDownIcon />}
        fontFamily="Roboto, sans-serif"
      >
        {languages.find((l) => l.code === language)?.nativeName || 'English'}
      </MenuButton>
      <MenuList bg={bgColor} borderColor={borderColor}>
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            bg="white"
            _hover={{ bg: 'gray.50' }}
            fontFamily="Roboto, sans-serif"
            color="black"
            fontWeight={language === lang.code ? '600' : '400'}
          >
            <HStack spacing={2} w="100%">
              <Text flex={1}>{lang.nativeName}</Text>
              {language === lang.code && (
                <Icon as={FaCheck} color="black" />
              )}
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageSelector;
